import { vec, type Vec2 } from '../geom';
import type { PointValue } from '../model';
import type { Evaluate, FieldSpec } from './types';

/** The x and y fields of a point-valued property such as `center`. */
export const pointFields = (prefix: string, label: string): FieldSpec[] => [
  { path: `${prefix}.x`, label: `${label} X`, unit: 'length', axis: 'x' },
  { path: `${prefix}.y`, label: `${label} Y`, unit: 'length', axis: 'y' },
];

export const pointValues = (prefix: string, point: Vec2): Record<string, number> => ({
  [`${prefix}.x`]: point.x,
  [`${prefix}.y`]: point.y,
});

export const evaluatePoint = (point: PointValue, evaluate: Evaluate): Vec2 =>
  vec(evaluate(point.x), evaluate(point.y));
